import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const Div = styled.div`
  height: 100%;
  width: 100%;
  z-index: 0;
  background: #ddd;
  padding-left: calc(14vw);
  padding-bottom: 20px;
  @media (max-width: 1280px) {
    padding-left: 200px;
  }
  @media (max-width: 508px) {
    padding-left: 10px;
  }
`;

export const ButtonS = styled.div`
  height: 100%;
  width: 100%;
  //padding-left: 10px;
  //background: rgb(211, 233, 239);
`;

export const Img = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  position: absolute;
  top: 5px;
`;

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(1),
  },
  card: {
    padding: theme.spacing(1),
    minWidth: 275,
  },
  large: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    color: 'white',
    background: 'white',
    // backgroundColor: white[500],
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'green',
    },
  },
  inline: {
    display: 'inline',
  },
}));
